export default __webpack_public_path__ + "90f3068d1019207055493545d119508f.png";